<template>
  <VView class="menu">
    <VBlock max-width="300px">
      <transition :name="getButtonTransitionName(item, index)"
        v-for="(item, index) in items" :key="index"
        appear
      >
        <VButton :to="item.to" :alternative="isLastButton(index)">{{ item.label }}</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
export default {
  name: 'Menu',

  data() {
    return {
      items: [
        { to: '/rules', label: this.$i18n.t('menu.rules') },
        { to: '/prizes', label: this.$i18n.t('menu.prizes') },
        { to: '/contest', label: this.$i18n.t('menu.contest') },
      ],
    };
  },

  methods: {
    getButtonTransitionName(item, index) {
      return index % 2 === 0
        ? 'bounceLeft'
        : 'bounceRight';
    },

    isLastButton(index) {
      return index === this.items.length - 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.menu {}
</style>
